export const FEATURE_NAMESPACE = 'feature.storage-levels'
